const getFileExtensionFromName = (fileName?: string | null) => {
  const extension = fileName?.split('.').pop()?.trim().toLowerCase()
  return extension && extension !== fileName?.toLowerCase() ? extension : ''
}

export function guessFileExtensionByContentType(
  contentType: string | null | undefined,
  fileName?: string | null
) {
  const normalizedContentType = (contentType || '')
    .split(';')[0]
    .trim()
    .toLowerCase()
  const extensionFromName = getFileExtensionFromName(fileName)

  if (
    extensionFromName &&
    (!normalizedContentType ||
      normalizedContentType === 'application/octet-stream' ||
      normalizedContentType === 'application/zip' ||
      normalizedContentType === 'application/x-zip-compressed')
  ) {
    return extensionFromName
  }

  switch (normalizedContentType) {
    case 'text/csv':
      return 'csv'
    case 'application/json':
      return 'json'
    case 'text/markdown':
      return 'md'
    case 'application/pdf':
      return 'pdf'
    case 'text/plain':
      return 'txt'
    case 'text/html':
      return 'html'
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'docx'
    case 'application/msword':
      return 'doc'
    case 'application/vnd.ms-excel':
      return 'xls'
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xlsx'
    case 'application/vnd.ms-excel.sheet.macroEnabled.12':
    case 'application/vnd.ms-excel.sheet.macroenabled.12':
    case 'application/vnd.ms-excel.sheet.macroenabled':
      return 'xlsm'
    case 'application/vnd.ms-powerpoint':
      return 'ppt'
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return 'pptx'
    // Audio file types
    case 'audio/mpeg':
    case 'audio/mp3':
      return 'mp3'
    case 'audio/wav':
    case 'audio/x-wav':
      return 'wav'
    case 'audio/mp4':
    case 'audio/x-m4a':
      return 'm4a'
    case 'audio/aac':
      return 'aac'
    case 'audio/flac':
      return 'flac'
    case 'audio/ogg':
      return 'ogg'
    case 'audio/webm':
      return 'webm'
    // Video file types
    case 'video/mp4':
      return 'mp4'
    case 'video/quicktime':
      return 'mov'
    case 'video/webm':
      return 'webm'
    case 'video/ogg':
      return 'ogg'
    case 'video/x-matroska':
      return 'mkv'
    case 'video/x-msvideo':
      return 'avi'
    default:
      if (extensionFromName) {
        return extensionFromName
      }

      // If it starts with "audio/", return "audio" as a general type
      if (normalizedContentType.startsWith('audio/')) {
        return 'audio'
      }
      if (normalizedContentType.startsWith('video/')) {
        return 'video'
      }
      return normalizedContentType.split('/').pop() || normalizedContentType
  }
}
